export default __webpack_public_path__ + "static/og-image-201f2d1d99e69ff11da6bb02f2e18f3e.jpg";